<template>
<div>
    <header class="header">
      <img src="../assets/zf-logo.png" width="100">
      <h1>中国房地产测评系列榜单后台</h1>
    </header>
    <a href="/#/admin/list">返回列表</a>
    <div class="grid-content bg-purple application-content">
      <h1>{{msg}}</h1>
      <el-row>
        <el-col :span="24">
          <div style="margin:14px 0;">
                <el-button-group>
                  <el-button type="primary" @click="dialogFormAddData = true">添加</el-button>
                  <el-button type="primary" @click="dialogFormImportDatas = true">数据导入</el-button>
                </el-button-group>
                </div>
        </el-col>
      </el-row>
      <el-table
        :data="list"
        align="left">
        <el-table-column label="序号" align="center" width="70">
          <template scope="scope"><span>{{scope.$index+(currentPage - 1) * countPerPage + 1}} </span></template>
        </el-table-column>
        <el-table-column
          prop="qname"
          label="企业简称"
          width="180">
        </el-table-column>
        <el-table-column
          prop="fullname"
          label="企业全称">
        </el-table-column>
      </el-table>
      <el-dialog title="添加新数据" :visible.sync="dialogFormAddData">
        <el-form :model="info" :rules="rules" ref="info">
          <el-form-item label="企业简称"  prop="qname" :label-width="formLabelWidth">
            <el-col :span="20">
              <el-input v-model="info.qname" auto-complete="off"></el-input>
              <!-- <el-input v-model="info.qname" auto-complete="off" @keyup.enter.native="handleIconClick" @focus="hideFocus(info.qname)" @blur="handleBlur(info.qname)" v-if="qnameShow"></el-input>
              <el-input v-model="qname" auto-complete="off" @keyup.enter.native="handleIconClick" @focus="handleFocus(qname)" @blur="handleBlur(qname)" v-if="!qnameShow"></el-input>
              <ul class="search-list" style="overflow-y: hidden;width:464px;top:40px;left:0;" v-if="nameList.length>0 && show">
                <div style="color:red;padding-left:20px;font-size:12px;">已经有数据了</div>

                  <el-col :span="24" v-for="(o,index) in nameList" :key="index"  @click.native="getFullName(o)">
                  <li class="cell" style="width:98%;display: flex;justify-content: space-between;">
                      <a href="javascript:;" @mousedown="getFullName(o)">{{o.qname}}</a>  
                      <a style="font-size:12px;" href="javascript:;" @mousedown="getFullName(o)">{{o.fullname}}</a>
                  </li>
                  </el-col>
              </ul> -->
            </el-col>
          </el-form-item>
          <el-form-item label="企业全称"  prop="fullname" :label-width="formLabelWidth">
            <el-col :span="20">
              <el-input v-model="info.fullname" auto-complete="off"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="" :label-width="formLabelWidth">
            <el-col :span="20">
              <el-button type="primary" @click="infoAdd(info)">保存</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="批量导入" :visible.sync="dialogFormImportDatas">
        <el-form :model="importData">
          <el-form-item label="上传文件" :label-width="formLabelWidth">
            <el-upload
              class="upload-demo"
              ref="upload"
              action="/"
              :on-change="fileChange"
              :file-list="fileList"
              accept=".csv"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <span style="margin-left:10px;" slot="tip" class="el-upload__tip">只能选取csv格式文件</span>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormImportDatas = false">取消</el-button>
          <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="importDatas">导入</el-button>
        </div>
      </el-dialog>  
    </div>
    <div>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[25, 50, 100, 200]"
          :page-size="countPerPage"
          layout="total, sizes, prev, pager, next"
          :total="total">
      </el-pagination>
    </div>
</div>
</template>
<script>
function getData(thisObj){
  thisObj.$http.get('/api/search/getEnterpriseNameList',
      {params: {
        where: {},
        countPerPage: thisObj.countPerPage, 
        currentPage: thisObj.currentPage
        }
      }).then(
        response => {
          thisObj.list = response.body.listArr;
          thisObj.total = response.body.total;
        },
        response => {
          console.log('failed');
        }
      )
}

export default {
  name: 'enterpriseName',
  data () {
   return {
      msg: "企业全称对应表",
      list:[],
      total:100,
      countPerPage: 25,
      currentPage: 1,
      dialogFormAddData: false,
      dialogFormImportDatas: false,
      formLabelWidth: '120px',
      info:{},
      importData:{},
      fileList: [],
      qname:'',
      nameList: [],
      show: false,
      qnameShow: false,
      fullscreenLoading: false,
      rules: {
        qname: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        fullname: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },

  mounted: function(){
    this.$nextTick(function () {
      getData(this);
    });
  },
  // watch: {
  //   qname:{
  //     handler:function(val,oldval){
  //         if(val){
  //           this.$http.get('/api/search/getEnameList', {params : {qname: val}}).then(
  //             response => {
  //               this.show = true;
  //               this.nameList = response.body;
  //             },
  //             response => {
  //               console.log('faild');
  //             }
  //           )
  //         }else{
  //           this.nameList.length = 0;
  //         }
  //     },
  //     deep:true//对象内部的属性监听，也叫深度监听
  //   }
  // },
  methods: {
    infoAdd(info) {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.$http.post('/api/search/addEnterpriseName',this.info).then( 
            response => {
            if(response.ok){
                this.$message({
                    showClose: true,
                    message: response.body.message,
                    type: 'success'
                  });
                  this.dialogFormAddData = false;
                  this.info = {};
                }
              this.$router.go(0);
            },
            response => {
              console.log('failed');
            }
          )
        } else {
          return false;
        }
      });
      
    },

    handleIconClick () {
      console.log(1);
    },
    // handleFocus (val) {
    //   this.$http.get('/api/search/getEnameList', {params : {qname: val}}).then(
    //     response => {
    //       this.show = true;
    //       this.nameList = response.body;
    //     },
    //     response => {

    //     }
    //   )
    // },
    // handleBlur (val) {
    //   this.show = false;
    //   this.qname = val;
    //   this.qnameShow = false;
    // },
    // getFullName (val){
    //   this.show = false;
    //   this.info.qname = val.qname;
    //   this.qnameShow = true;
    //   this.info.fullname = val.fullname;
    // },
    // hideFocus (){
    //   this.qname = this.info.qname;
    //   this.qnameShow = false;
    // },

    handleSizeChange (val){
      this.countPerPage = val;
      getData(this);
    },
    handleCurrentChange (val){
      this.currentPage = val;
      getData(this);
    },
    
    fileChange(file, fileList) {
      var that = this;
      var fReader = new FileReader();
      fReader.readAsDataURL(file.raw);
      fReader.onload = function(evt){
        var data = evt.target.result;
          var encoding = checkEncoding( data );
          Papa.parse( file.raw, {
              header: true,
              download: true,
              encoding: encoding,
              complete: function(results) {   // UTF8 \r\n与\n混用时有可能会出问题
                var res = results.data;
                console.log(res);
                var arrRes = [];
                if( (res[res.length-1].qname == undefined) || (res[res.length-1].qname == '')){ //去除最后的空行
                  res.pop();
                } console.log(that.importData);
                for(var i = 0; i < res.length; i++){
                  arrRes[i] = $.extend(res[i], that.importData);
                }
                that.csvValue = arrRes;
              }
          });
      }
    },

    importDatas(){
      this.$http.post('api/search/batchEnterpriseNames', this.csvValue).then(  //插入多条数据
          response => {
            this.fullscreenLoading = true;
            if(response.ok){
              this.$message({
                    showClose: true,
                    message: response.body,
                    type: 'success'
                  });
              this.dialogFormImportDatas = false;
            }else{
              $this.$message({
                showClose: true,
                message: '没有可添加的新数据，有可能都是重复数据'
              });
              this.dialogFormImportDatas = false;
            }
            setTimeout(() => {
              this.fullscreenLoading = false;
              this.$router.go(0);
            }, 2000);
          },
          response => {
            console.log('failed');
          }
       );
    }
  }

}



</script>



// WEBPACK FOOTER //
// src/components/AddEnterpriseName.vue